import { render, staticRenderFns } from "./AccountNumberHistory.vue?vue&type=template&id=04e896cb"
import script from "./AccountNumberHistory.vue?vue&type=script&lang=js"
export * from "./AccountNumberHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e896cb')) {
      api.createRecord('04e896cb', component.options)
    } else {
      api.reload('04e896cb', component.options)
    }
    module.hot.accept("./AccountNumberHistory.vue?vue&type=template&id=04e896cb", function () {
      api.rerender('04e896cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/accountNumber/AccountNumberHistory.vue"
export default component.exports